import { createConfiguration, Time } from "@hyper-fetch/core";

import type { ApiRoutesSdk } from "@complete-athlete/backend";

export const userConfiguration = createConfiguration<ApiRoutesSdk>()({
  "users.me.$get": { cacheTime: Infinity, staleTime: Time.MIN * 5, deduplicate: true },
});
